import type { PartialCancellationFeeData, PartialCancellationFeeState } from './types'

export const DEFAULT_PARTIAL_CANCELLATION_FEE_STATE: PartialCancellationFeeState = {
  status: 'idle',
  participants: [],
  isFreeCancellationAllowed: false,
  isCancellationWithCostsAllowed: false,
}

export function isPartialCancellationFeeDataValid(data: PartialCancellationFeeData): boolean {
  return data.isFreeCancellationAllowed || data.participants.length > 0
}

export function normalizePartialCancellationFeeData(data: PartialCancellationFeeData): PartialCancellationFeeData {
  if (data.participants.length > 0 && data.isFreeCancellationAllowed) {
    return {
      ...data,
      isFreeCancellationAllowed: false,
    }
  }

  return data
}
